export enum StaffColumnKey {
  StaffFirstName = 'firstName',
  StaffLastName = 'lastName',
  StaffEmail = 'email',
  StaffRole = 'role',
  Status = 'status',
  Actions = 'actions',
}
